import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://dryoussefgam-backend.chadiayari1998-7e8.workers.dev",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("jwtToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export { axiosInstance };
